import { v4 } from 'uuid'

export const NotificationItemVariant = {
  Success: 'success' as const,
  Error: 'error' as const,
  Warning: 'warning' as const,
  Info: 'info' as const,
}

export type NotificationItemVariant = 'success' | 'error' | 'warning' | 'info'

export class NotificationItem {
  id: string
  title: string
  variant: NotificationItemVariant

  constructor(title: string, variant: NotificationItemVariant) {
    this.id = v4()
    this.title = title
    this.variant = variant
  }
}
